(function () {
    'use strict';

    angular
        .module('core.services')
        .service('ResponsibilityService', ResponsibilityService)

    /** @ngInject */
    function ResponsibilityService(HttpService) {
        const ResponsibilityService = {
            get,
            getAll,
            getByParameters,
            post,
            put,
            migrateData,
            deleteData
        }

        return ResponsibilityService;

        function get(responsibilityId) {
            return HttpService.get(`/responsibilities/${responsibilityId}`);
        }

        function getAll() {
            return HttpService.get('/responsibilities/by-parameters', {
                params: {}
            });
        }

        function getByParameters(params) {
            return HttpService.get('/responsibilities/by-parameters', {
                params
            });
        }

        function post(responsibilityData) {
            return HttpService.post('/responsibilities', responsibilityData);
        }

        function put(responsibilityData) {
            return HttpService.put('/responsibilities', responsibilityData);
        }

        function migrateData(responsibilityOriginId, responsibilityDestinationId) {
            return HttpService.put(`/responsibilities/migrate/${responsibilityOriginId}/${responsibilityDestinationId}`);
        }

        function deleteData(responsibilityId) {
            return HttpService.delete(`/responsibilities/${responsibilityId}`);
        }
    }
}());